import { c as _c } from "react/compiler-runtime";
import { PrimaryButton } from '@systemeio/ui';
import MobileSettingsHeader from 'modules/funnels/funnel/components/mobile-settings-header';
import { useDeviceMode } from 'modules/funnels/funnel/context/device-mode-context';
import { FunnelStepSettingTabsEnum } from 'modules/funnels/funnel/enums/funnel-step-setting-tabs-enum';
import ChangeIconNew from 'modules/funnels/funnel/icons/change-icon-new';
import React, { useState, type JSX } from 'react';
import ConfirmationModal from 'shared/components/confirmation-modal';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useWindowSize from 'shared/hooks/use-window-size';
import EditIcon from '../../icons/edit-icon';
import { EyeIcon } from '@systemeio/ui/icons';
interface StepConfigurationTabLayoutProps {
  children: JSX.Element;
  viewLinkUrl: string;
  editLinkUrl: string;
  onChangeTemplate: () => Promise<void>;
  additionalAction?: JSX.Element;
  customEditButton?: JSX.Element;
  customViewButton?: JSX.Element;
}
function StepConfigurationTabLayout(t0) {
  const $ = _c(38);
  const {
    children,
    viewLinkUrl,
    editLinkUrl,
    onChangeTemplate,
    additionalAction,
    customEditButton,
    customViewButton
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const [changeTemplateConfirmationOpen, setChangeTemplateConfirmationOpen] = useState(false);
  const {
    isMobile
  } = useDeviceMode();
  const {
    width
  } = useWindowSize();
  const isDesktopMode = width > 1170;
  const t1 = `flex ${isDesktopMode ? "flex-row" : "flex-col-reverse"} gap-7 px-[15px] pb-5 lg:gap-5 lg:px-[15px] lg:pb-7 xl:gap-10 ${isMobile ? "bg-background-secondary rounded-lg" : ""}`;
  let t2;
  if ($[0] !== children) {
    t2 = <div className="w-full lg:w-4/5">{children}</div>;
    $[0] = children;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== customViewButton || $[3] !== t || $[4] !== viewLinkUrl) {
    t3 = customViewButton ? customViewButton : <PrimaryButton as={LinkWithoutPrefetch} className="!justify-start" href={viewLinkUrl} target="_blank" data-test-element="view-funnel-step-button"><EyeIcon className="fill-background-secondary h-[20px] w-[20px]" /><span className="text-start">{t("dashboard.funnel.configuration.common.view_funnel_step")}</span></PrimaryButton>;
    $[2] = customViewButton;
    $[3] = t;
    $[4] = viewLinkUrl;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== customEditButton || $[7] !== editLinkUrl || $[8] !== t) {
    t4 = customEditButton ? customEditButton : <PrimaryButton as={LinkWithoutPrefetch} className="!justify-start" href={editLinkUrl} target="_self" data-test-element="edit-page-funnel-step-button"><EditIcon className="fill-background-secondary h-[18px] w-[18px]" /><span className="text-start">{t("dashboard.funnel.configuration.common.edit_page")}</span></PrimaryButton>;
    $[6] = customEditButton;
    $[7] = editLinkUrl;
    $[8] = t;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => setChangeTemplateConfirmationOpen(true);
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <ChangeIconNew className="fill-background-secondary h-[18px] w-[18px]" />;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t) {
    t7 = t("dashboard.funnel.configuration.common.change_page_template");
    $[12] = t;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t7) {
    t8 = <PrimaryButton className="!justify-start" onClick={t5} data-test-element="change-page-template-funnel-step-button">{t6}<span className="text-start">{t7}</span></PrimaryButton>;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== additionalAction || $[17] !== t3 || $[18] !== t4 || $[19] !== t8) {
    t9 = <div className="flex flex-col gap-4 xl:ml-auto">{t3}{t4}{t8}{additionalAction}</div>;
    $[16] = additionalAction;
    $[17] = t3;
    $[18] = t4;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <MobileSettingsHeader type={FunnelStepSettingTabsEnum.stepConfiguration} />;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t1 || $[23] !== t2 || $[24] !== t9) {
    t11 = <div className={t1}>{t2}{t9}{t10}</div>;
    $[22] = t1;
    $[23] = t2;
    $[24] = t9;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== t) {
    t12 = t("dashboard.funnel.configuration.common.change_page_template_confirm");
    $[26] = t;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = () => setChangeTemplateConfirmationOpen(false);
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== onChangeTemplate) {
    t14 = () => onChangeTemplate();
    $[29] = onChangeTemplate;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== changeTemplateConfirmationOpen || $[32] !== t12 || $[33] !== t14) {
    t15 = <ConfirmationModal confirmationText={t12} opened={changeTemplateConfirmationOpen} onClose={t13} onConfirm={t14} />;
    $[31] = changeTemplateConfirmationOpen;
    $[32] = t12;
    $[33] = t14;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== t11 || $[36] !== t15) {
    t16 = <>{t11}{t15}</>;
    $[35] = t11;
    $[36] = t15;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  return t16;
}
export default StepConfigurationTabLayout;